<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 95vw">
      <!-- HEADER -->
      <div class="modal-header">
        <h5 class="modal-title">
          Ascertain Bills and Quantities for Insurance
        </h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <!-- BODY -->
      <div class="modal-body">
        <!-- Insurance selection -->
        <div class="mb-3 d-flex gap-2">
          <div class="flex-fill">
            <label for="insurance-company" class="form-label"
              >Insurance Company</label
            >
            <select
              id="insurance-company"
              class="form-control"
              v-model="selectedCompany"
              @change="get_schemes"
            >
              <option
                v-for="company in insuranceCompanies"
                :key="company.id"
                :value="company.id"
              >
                {{ company.name }}
              </option>
            </select>
          </div>
          <div class="flex-fill">
            <label for="insurance-scheme" class="form-label"
              >Insurance Scheme</label
            >
            <select
              id="insurance-scheme"
              class="form-control"
              v-model="selectedScheme"
            >
              <option
                v-for="scheme in insuranceSchemes"
                :key="scheme.id"
                :value="scheme.id"
              >
                {{ scheme.scheme_name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Select All -->
        <div class="mb-2">
          <input
            type="checkbox"
            id="select-all"
            v-model="selectAll"
            @change="toggleSelectAll"
          />
          <label for="select-all">Select / Unselect All</label>
        </div>

        <!-- Bills table -->
        <table class="table table-bordered">
          <thead style="padding: 0; margin: 0">
            <tr>
              <th scope="col" class="p-0 m-0">Select</th>
              <th scope="col" class="p-0 m-0">Service/Product</th>
              <th scope="col" class="p-0 m-0">Quantity</th>
              <th scope="col" class="p-0 m-0">Unit Price</th>
              <th scope="col" class="p-0 m-0">Amount</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="bill in modifiedBills" :key="bill.id">
              <td>
                <input type="checkbox" v-model="selectedBills" :value="bill" />
              </td>
              <td>{{ bill.charge_name }}</td>
              <td>
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  v-model.number="bill.insurance_quantity"
                  @input="updateAmount(bill)"
                />
              </td>
              <td>{{ bill.unit_price }}</td>
              <td>{{ bill.amount_due }}</td>
            </tr>
            <tr v-if="modifiedBills.length === 0">
              <td colspan="5" class="text-center">No bills available</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closeModal">Cancel</button>
        <button class="btn btn-primary" @click="submitBills">
          Submit Selected Bills
          <span class="badge bg-light text-dark ms-2">{{
            selectedBills.length
          }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "InsuranceBillModal",
  props: {
    bills: {
      type: Array,
      required: true,
    },
    // invoice_id: {
    //   type: [Number, String],
    //   required: true,
    // },
  },
  data() {
    return {
      // Reactive copy of bills for editing
      modifiedBills: this.bills.map((b) => ({
        ...b,
        insurance_quantity: b.quantity,
        amount_due: b.quantity * b.unit_price,
      })),
      selectedBills: [],
      selectAll: true,

      insuranceCompanies: [],
      insuranceSchemes: [],
      selectedCompany: "",
      selectedScheme: "",
    };
  },
  watch: {
    selectAll(newVal) {
      if (newVal) {
        this.selectedBills = [...this.modifiedBills];
      } else {
        this.selectedBills = [];
      }
    },
  },
  mounted() {
    // Initially select all bills
    this.selectedBills = [...this.modifiedBills];
    this.get_insurance_companies();
  },
  methods: {
    closeModal() {
      this.$emit("close-conf");
    },
    get_schemes() {
      this.get_insurance_schemes();
    },
    updateAmount(bill) {
      bill.amount_due =
        Number(bill.insurance_quantity) * Number(bill.unit_price);
    },
    toggleSelectAll() {
      this.selectAll = !this.selectAll;
    },
    async get_insurance_companies() {
      const companies = await generalApiRequest(
        "insurance/org-insurance",
        "GET",
        {},
        1
      );
      this.insuranceCompanies = companies;
    },
    async get_insurance_schemes() {
      const schemes = await generalApiRequest(
        "insurance/org-schemes/" + this.selectedCompany,
        "GET",
        {},
        1
      );
      this.insuranceSchemes = schemes;
    },
    submitBills() {
      if (!this.selectedCompany) {
        return alert("Please select insurance company and scheme!");
      }
      if (this.selectedBills.length === 0) {
        return alert("No bills selected!");
      }

      const payload = this.selectedBills.map((b) => ({
        ...b, // keep everything from the original object
        bill_id: b.id, // override / add these fields
        quantity: b.insurance_quantity,
        unit_price: b.unit_price,
        is_insurance: 1,
        insurance_company_id: this.selectedCompany,
        insurance_scheme_id: this.selectedScheme,
        amount: parseFloat(b.insurance_quantity) * parseFloat(b.unit_price),
        amount_due: parseFloat(b.insurance_quantity) * parseFloat(b.unit_price),
      }));

      const req_body = {
        invoice_id: this.$route.params.invoiceid,
        insurance_company_id: this.selectedCompany,
        insurance_scheme_id: this.selectedScheme,
        bill_items: payload,
      };

      console.log(req_body);

      generalApiRequest(
        "insurance/sort_bills_to_insurance",
        "POST",
        req_body,
        1
      ).then((res) => {
        console.log("API response:", res);
        // alert("Bills sent to insurance successfully!");
        this.selectedBills = [];
        this.closeModal();
      });
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  max-width: 95vw;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
}

.modal-header,
.modal-footer {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
}

.modal-footer {
  border-top: 1px solid #ddd;
}

.modal-body {
  padding: 1rem;
  max-height: 60vh;
  overflow-y: auto;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
